module.exports = __webpack_public_path__ + "img/edit-icon.3ae6b956.svg";